import { AxiosError } from 'axios';
import { utilities } from 'core';

type MinimalState = {
  data: undefined | any;
  isSuccess: boolean;
  isError: boolean;
  isLoading: boolean;
  error: any;
};
const defaultState: MinimalState = {
  data: undefined,
  isSuccess: false,
  isError: false,
  isLoading: false,
  error: {} as AxiosError,
};

export function createReducer<Type>(Action: any) {
  return utilities.createReducer<Type & MinimalState>(
    {
      [Action.setData]: (draft, { payload }) => {
        draft.data = payload;
      },
      [Action.setIsSuccess]: (draft, { payload }) => {
        draft.isSuccess = true;
        draft.isError = false;
        draft.isLoading = false;
      },
      [Action.setIsError]: (draft, { payload }) => {
        draft.isError = true;
        draft.isSuccess = false;
        draft.isLoading = false;
      },
      [Action.setIsLoading]: (draft, { payload }) => {
        draft.isLoading = true;
        draft.isError = false;
        draft.isSuccess = false;
      },
    },
    defaultState as any,
  );
}
